module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-sm-12 col-xs-12 pull-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('router-link', {
    attrs: {
      "to": '/store/' + _vm.company.comid
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.company.com_name) + "\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('figure', {
    staticClass: "pic"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": 'https://files.i80.com.tw/images/product/' + _vm.rowData.imageL
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rowData.short))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled product_intro"
  }, [_c('li', {
    staticClass: "price_box"
  }, [(_vm.rowData.price > 0) ? _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.rowData.price))]) : _vm._e(), _vm._v(" "), (_vm.rowData.point > 0) ? _c('p', {
    staticClass: "points"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-gift"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t    " + _vm._s(_vm.rowData.point) + " 點\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), (_vm.rowData.price > 0) ? _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("數量")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control amount",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderNumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.numbers), function(number) {
    return _c('option', {
      domProps: {
        "value": number
      }
    }, [_vm._v(_vm._s(number))])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.company.com_shopping == 'Y') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.rowData)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 加入購物車\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.company.com_shopping == 'N') ? _c('p', [_vm._v("\n                  暫無開放線上購物，請聯絡店家進行購買 " + _vm._s(_vm.company.com_phone) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exampleModalCenter"
    }
  }, [_vm._v("\n                  優惠方案\n                ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                分享到：\n                "), _c('social-sharing', {
    attrs: {
      "url": _vm.shareLink,
      "title": _vm.rowData.name,
      "description": _vm.rowData.name,
      "hashtags": "i80"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fab fa-facebook fa-2x"
          }), _vm._v(" Facebook\n                    ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "pinterest"
            }
          }, [_c('i', {
            staticClass: "fab fa-fw fa-2x fa-pinterest"
          }), _vm._v(" Pinterest\n                    ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "line"
            }
          }, [_c('i', {
            staticClass: "fab fa-line fa-2x"
          }), _vm._v(" Line\n                    ")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("產品介紹")]), _vm._v(" "), _c('p', {
    staticClass: "editor",
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": _vm.shareLink,
      "data-share": "true",
      "data-width": "120",
      "data-show-faces": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": _vm.id,
      "data-num-posts": "2",
      "data-width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-12 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("你可能會喜歡")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.popular), function(item, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "product_box"
    }, [_c('a', {
      attrs: {
        "href": '/product/' + item.id
      }
    }, [_c('figure', {
      staticClass: "pic"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageM
      }
    })])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "points"
    }, [(item.point > 0) ? _c('span', {
      staticClass: "glyphicon glyphicon-gift",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.point) + " 點\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (item.price > 0) ? _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e()])])
  }))])])])]), _vm._v(" "), _vm._m(4, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("聯盟店家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline payment"
  }, [_c('li', [_vm._v("信用卡")]), _vm._v(" "), _c('li', [_vm._v("ATM")]), _vm._v(" "), _c('li', [_vm._v("iBon")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModalCenter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("活動訊息")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n              愛幫您的會員您好，只要按下分享愛幫您將贈送給您免費商品。"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("關閉")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e07d2d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoreProductView.vue
// module id = 307
// module chunks = 1